import { useRef } from 'react';
import Utils from '../utils';

const BookSlideList = ({ scripts = [], onBookClick }) => {
  const shelfRef = useRef(null)

  const moveShelf = (direction) => {
    const shelf = shelfRef.current
    if (!shelf) return
    const firstCard = shelf.querySelector('.home-featured-card')
    const distance = (firstCard?.getBoundingClientRect().width || shelf.clientWidth) + 14
    shelf.scrollBy({
      left: direction * distance,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    })
  }

  return <>
    <div className='home-book-shelf' ref={shelfRef}>
      {scripts.map(script => {
        const isSample = Utils.isSampleScript(script)
        return <button
          className='home-featured-card'
          type='button'
          key={script.scriptNo}
          onClick={() => onBookClick(script.scriptNo, isSample)}
          aria-label={`${script.title} ${isSample ? '미리보기' : '읽기'}`}
        >
          <div className='home-featured-cover'>
            <img src={script.mainImageUrl} alt='' loading='lazy' width='320' height='260' />
            {isSample && <span className='home-sample-badge'>미리보기</span>}
          </div>
          <div className='home-featured-copy'>
            <h3>{script.title}</h3>
            <p>{script.summary}</p>
            <span className='home-featured-cta'>동화 읽기 <span aria-hidden='true'>↗</span></span>
          </div>
        </button>
      })}
    </div>
    {scripts.length > 1 && <div className='home-shelf-controls'>
      <span>옆으로 넘겨 더 많은 이야기를 만나보세요</span>
      <div>
        <button type='button' onClick={() => moveShelf(-1)} aria-label='이전 이야기'><span aria-hidden='true'>‹</span></button>
        <button type='button' onClick={() => moveShelf(1)} aria-label='다음 이야기'><span aria-hidden='true'>›</span></button>
      </div>
    </div>}
  </>
}

export default BookSlideList
